<app-autocomplete-select (optionClicked)="onSelectGoogleAddress($event)" (searchChanged)="onSearchGoogleChange($event)"
                         [dataSource]="searchGoogleResults" optionTemplate="data.description" placeholder="Adresse, lieu, ...">
</app-autocomplete-select>
